"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRating = exports.STAR_FILLED = exports.STAR_HALF = exports.STAR_EMPTY = void 0;
exports.STAR_EMPTY = 'EMPTY';
exports.STAR_HALF = 'HALF';
exports.STAR_FILLED = 'FILLED';
const getRating = (rating, maxRating) => {
    const LOWER_BOUND_FOR_HALF_FILLED = 0.2;
    const UPPER_BOUND_FOR_HALF_FILLED = 0.7;
    const integerRating = Math.floor(rating);
    const ratings = [];
    for (let i = 0; i < maxRating; i++) {
        if (i < integerRating || (i < rating && rating > integerRating + UPPER_BOUND_FOR_HALF_FILLED)) {
            ratings.push(exports.STAR_FILLED);
        }
        else if (i === integerRating && rating > (integerRating + LOWER_BOUND_FOR_HALF_FILLED)) {
            ratings.push(exports.STAR_HALF);
        }
        else {
            ratings.push(exports.STAR_EMPTY);
        }
    }
    return ratings;
};
exports.getRating = getRating;
